<template functional>
  <div v-if="props.item.drayage_mode != 'port'">
    <div>{{ props.item.eta_fmt }}</div>
    <div class="text-2xs">{{ props.item.eta_time }}</div>
  </div>
</template>

<script>
export default {
  name: "drayage-eta",
  functional: true,
  props: {
    item: Object,
    options: Object,
  },
};
</script>
